<template>
	<div>
		<pageHead></pageHead>
		<div class="service-main">
			<page-banner :title="'服务内容'" :tipTxt="'提供“规范、科学、公正、专业、诚信”的等级保护测评服务'"></page-banner>
			
			<div class="proBox">
				<div class="proImgBox" @click="goTo('/equal')">
					<div>
						<img src="../../assets/img/service/db.png" alt="">
						<p>等保测评</p>
					</div>
				</div>
				<div class="proImgBox" @click="goTo('/confidential')">
					<div>
						<img src="../../assets/img/service/mp.png" alt="">
						<p>密评咨询</p>
					</div>
				</div>
				<div class="proImgBox" @click="goTo('/software')">
					<div>
						<img src="../../assets/img/service/cs.png" alt="">
						<p>软件测试</p>
					</div>
				</div>
				<div class="proImgBox" @click="goTo('/vulnerability')">
					<div>
						<img src="../../assets/img/service/ls.png" alt="">
						<p>漏洞扫描</p>
					</div>
				</div>
				<div class="proImgBox" @click="goTo('/risk')">
					<div>
						<img src="../../assets/img/service/fx.png" alt="">
						<p>风险评估</p>
					</div>
				</div>
		
				
				<div class="proImgBox" @click="goTo('/safety')">
					<div>
						<img src="../../assets/img/service/aq.png" alt="">
						<p>安全培训</p>
					</div>
				</div>
				<div class="proImgBox" @click="goTo('/emergency')">
					<div>
						<img src="../../assets/img/service/yj.png" alt="">
						<p>应急响应</p>
					</div>
				</div>
				<div class="proImgBox" @click="goTo('/penetration')">
					<div>
						<img src="../../assets/img/service/st.png" alt="">
						<p>渗透测试</p>
					</div>
				</div>
				<div class="proImgBox" @click="goTo('/computer')">
					<div>
						<img src="../../assets/img/service/jf.png" alt="">
						<p>机房检测</p>
					</div>
				</div>
				<div class="proImgBox" @click="goTo('/code')">
					<div>
						<img src="../../assets/img/service/dm.png" alt="">
						<p>代码审计</p>
					</div>
				</div>
			</div>
		</div>
		
		<page-foot></page-foot>
	</div>
</template>

<script>
	import pageHead from '../../components/pageHead'
	import pageBanner from '../../components/pageBanner'
	import pageFoot from '../../components/pagefoot'
	export default{
		components:{
			pageHead,
			pageBanner,
			pageFoot
		},
		data(){
			return {
				
			}
		},
		methods:{
			goTo(path){
				this.$router.push({
					path:path
				})
			}
		}
	}
</script>

<style scoped>
.proBox{
	width: 100%;
	max-width: 1440px;
	margin: 0 auto;
	height: 680px;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	justify-content: space-around;
	border-radius: 15px;
}
.proImgBox{
	width: 20%;
	box-sizing: border-box;
	font-size: 20px;
	text-align: center;
	display: flex;
	justify-content: center;
}
.proImgBox>div{
	width: 140px;
	cursor: pointer;
}
.proImgBox img{
	width: 120px;
	height: 120px;
	margin-bottom: 20px;
}
.serviceT{
	font-size: 24px;
	line-height: 100px;
	font-weight: 800;
}
@keyframes scrollY {
  100% {
    transform: translateY(0); 
  }
}
</style>